import { createProxySignalFactory, ProxySignal } from '@lg/shared'
import {
	signal,
	computed,
	isSignal,
	Signal,
	WritableSignal,
} from '@angular/core'

export { signal, computed, ProxySignal, isSignal, Signal, WritableSignal }

const proxySignals = createProxySignalFactory({ signal, computed })
export const proxySignal = proxySignals.proxySignal
export const proxySignalDeferred = proxySignals.proxySignalDeferred
